import Emitter from "../../core/Emitter";

export default class Sizes {
    constructor() {
        //Setup
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.fixedPixelRatio = 1;
        this.pixelRatio = this.fixedPixelRatio;
        //this.pixelRatio = Math.min(window.devicePixelRatio, 2);

        // Resize Event
        window.addEventListener('resize', () => {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.pixelRatio = this.fixedPixelRatio;
            //this.pixelRatio = Math.min(window.devicePixelRatio, 2);
            Emitter.emit('resize')
        })
    }
}